import React, { useState } from 'react';
import { CONTRACT_STATUS_OPTIONS } from './constants';

/**
 * Form for admin to update user's contract status.
 * Reusable from user detail modal (edit mode) or any page that edits user.
 */
const UserContractStatusForm = ({ user, onSave, onCancel, saving = false }) => {
  const [contractStatus, setContractStatus] = useState(
    user?.contractStatus || 'not started'
  );
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (contractStatus === (user?.contractStatus || 'not started')) {
      onCancel?.();
      return;
    }
    try {
      await onSave({ contractStatus });
    } catch (err) {
      setError(err.message || 'Failed to update contract status');
    }
  };

  if (!user) return null;

  return (
    <form onSubmit={handleSubmit} className="border border-gray-200 rounded-lg p-4 bg-gray-50">
      <h5 className="text-sm font-medium text-gray-700 mb-3">Update contract status</h5>
      <div className="flex flex-wrap items-end gap-3">
        <div className="flex-1 min-w-[180px]">
          <label htmlFor="contractStatus" className="block text-xs text-gray-500 mb-1">
            Contract Status
          </label>
          <select
            id="contractStatus"
            value={contractStatus}
            onChange={(e) => setContractStatus(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm"
            disabled={saving}
          >
            {CONTRACT_STATUS_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
        <div className="flex gap-2">
          <button
            type="submit"
            disabled={saving}
            className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 disabled:opacity-50 text-sm font-medium"
          >
            {saving ? 'Saving...' : 'Save'}
          </button>
          <button
            type="button"
            onClick={onCancel}
            disabled={saving}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 disabled:opacity-50 text-sm font-medium"
          >
            Cancel
          </button>
        </div>
      </div>
      {error && (
        <p className="mt-2 text-sm text-red-600" role="alert">
          {error}
        </p>
      )}
    </form>
  );
};

export default UserContractStatusForm;
